import { atom } from 'recoil'

const TimeOfBirthState = atom({
  key: 'TimeOfBirthState',
  default: 0,
})
const FortuneResultData = atom({
  key: 'FortuneResultData',
  default: [],
})
export { FortuneResultData, TimeOfBirthState }
